import React from 'react';
import Main from '../../components/layout/Main';
import useUsers from '../../hooks/useUsers';
import UserCard from './UserCard';
function Community() {
  const usersQuery = useUsers();

  if (!usersQuery.isSuccess) return null;

  return (
    <Main
      contentLeft={null}
      contentRight={null}
      main={
        <div className="m-8 mt-12 flex flex-col space-y-8">
          <p className="font-bold text-lg text-transparent bg-clip-text bg-gradient-to-r from-sky to-teal-500 mb-10">
            Community
          </p>
          <ul className="grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 max-w-full">
            {usersQuery.data.map((user: any) => {
              return <UserCard key={user._id} {...user} />;
            })}
          </ul>
        </div>
      }
    />
  );
}

export default Community;
